import { Heading } from "monday-ui-react-core";
import React from "react";
import styled from "styled-components";

import type { Board } from "@/types/common";
import type { CheckOption } from "@/types/common";

import { BoardSelection } from "./BoardSelection";

interface SelectItemsLayoutProps {
  boards: Board[];
  boardId: number;
  children?: React.ReactNode;
  allBoardItemsFlag: CheckOption;
  onAllBoardItemsFlagChange: () => unknown;
}

export function SelectItemsLayout({
  boards,
  boardId,
  children,
  onAllBoardItemsFlagChange,
  allBoardItemsFlag,
}: SelectItemsLayoutProps) {
  return (
    <SelectItemsLayoutWrapper>
      <Heading type={Heading.types.h2} value="Select items to clone" style={{ padding: "0px", margin: "0px" }} />
      <BoardSelection
        boards={boards}
        boardId={boardId}
        onAllBoardItemsFlagChange={onAllBoardItemsFlagChange}
        allBoardItemsFlag={allBoardItemsFlag}
      />
      <ContentWrapper>{children}</ContentWrapper>
    </SelectItemsLayoutWrapper>
  );
}

const SelectItemsLayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  padding: var(--spacing-small);
  padding-left: 38px;
  padding-right: var(--spacing-xl);
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 300px;
  height: 100%;
`;
